module.exports = __webpack_public_path__ + "static/img/looksan.7ef2ddca.jpg";